import { render, staticRenderFns } from "./ReportMealsTabOrders.vue?vue&type=template&id=8f563fa2"
import script from "./ReportMealsTabOrders.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports